import instance from "../utils/network";

export function checkIsBan(): Promise<boolean> {
  return instance.get("/nest/game-ban");
}
